<template>
<div class="container-fluid">
	<div class="row">
	    <div class="col-12">	    			
			<h1>
				Smart List: New Physicians
				<span class="d-none d-md-inline text-transform-none font-weight-normal" style="letter-spacing:0;">(Physicians created in the last 30 days.)</span>
			</h1>
			<div class="page-with-title">
				<physician-map-and-table
					v-if="data_loaded"
					:physician_data="physicians"
					:client_metrics="user.client.client_metrics ? user.client.client_metrics : null"
					:default_latitude="user.client.latitude ? user.client.latitude : null"
					:default_longitude="user.client.longitude ? user.client.longitude : null"
					default_sort_field="last_name"
					default_sort_direction="asc"
					default_per_page="50"
					:data_loaded="data_loaded"
				/>

				<div v-else class="page-with-title fill-app-height">
					<img class="center-me" src="/images/loading-color.svg">
				</div>
			</div>
		</div>
	</div>
</div>
</template>

<script>	
    import { mapState } from 'vuex'
    import BreadcrumbsManager from '../../helpers/BreadcrumbManager';

	export default {
		mixins: [BreadcrumbsManager],

		data(){
			return {
				physicians: [],
				data_loaded: false,
			}
		},

		created() {
			this.fetchPhysicians();
		},

        activated() {
            this.setBreadcrumbs([
                { text: 'Home', to: { name: 'home' } },
                { text: 'Providers', to: { name: 'physicians.list'} },
                { text: 'Smart Lists', to: { name: 'smart_lists.index'} },
                { text: 'New Physicians', to: { name: 'smart_lists.new'} },
            ]); 	
        },

		methods: {
			fetchPhysicians() {
				axios.get('/api/physicians/smart-lists/new').then(({data}) => {
                    this.physicians = data;
                    this.data_loaded = true;
                });
				
			}
		},

		computed: mapState(['user'])
	}
</script>